// extracted by mini-css-extract-plugin
export default {"page":"PlansPage_page__1qfn6","wrapper":"PlansPage_wrapper__AovrD"};